import React from "react";
import { Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { HiOutlineArrowRight } from "react-icons/hi2";
import { c } from "../classroomColors";
import { blueButton, quietButton } from "./parts";
import { STATE, clock, plural } from "./spaceTokens";

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(255, 74, 74, 0.45); }
  70% { box-shadow: 0 0 0 8px rgba(255, 74, 74, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 74, 74, 0); }
`;

/**
 * A session that is live, leading the space beside the work: a white card
 * marked by its pulsing red dot, with the way in. Shown only while a
 * session is live.
 */
const LiveCard = ({ session, isInstructor, studentCount, onEnter, onOpen }) => {
  const joined = session.attended_count || 0;
  return (
    <Flex
      align={{ base: "flex-start", sm: "center" }}
      direction={{ base: "column", sm: "row" }}
      gap="18px"
      h="100%"
      p={{ base: "16px", md: "18px 20px" }}
      borderRadius="18px"
      bg={c.surface}
      border="1px solid"
      borderColor={c.borderSoft}
    >
      <Box flex="1" minW={0}>
        <Flex align="center" gap="8px" mb="6px">
          <Box
            boxSize="8px"
            borderRadius="full"
            bg={STATE.LIVE.dot}
            animation={`${pulse} 1.8s ease-out infinite`}
            sx={{ "@media (prefers-reduced-motion: reduce)": { animation: "none" } }}
          />
          <Text fontSize="12px" fontWeight="600" letterSpacing="0.08em" textTransform="uppercase" color={c.text}>
            Live now
          </Text>
          {session.started_at && (
            <Text fontSize="12.5px" color={c.textSub}>
              · since {clock(session.started_at)}
            </Text>
          )}
        </Flex>
        <Text fontSize="22px" fontWeight="600" color={c.text} letterSpacing="-0.01em" lineHeight="1.25" noOfLines={2}>
          {session.name}
        </Text>
        <Text fontSize="13px" color={c.textSub} mt="4px">
          {isInstructor && studentCount
            ? `${joined}/${studentCount} joined`
            : joined
            ? `${plural(joined, "student")} joined so far`
            : "The room is open"}
        </Text>
      </Box>
      <Flex gap="8px" flexShrink={0} w={{ base: "100%", sm: "auto" }}>
        <Button {...quietButton} h="44px" px="16px" borderRadius="13px" fontSize="13.5px" onClick={() => onOpen(session)}
          flex={{ base: "1", sm: "none" }}>
          Details
        </Button>
        <Button {...blueButton} h="44px" px="20px" borderRadius="13px" fontSize="14px"
          rightIcon={<Icon as={HiOutlineArrowRight} boxSize="15px" />} onClick={() => onEnter(session)}
          flex={{ base: "1", sm: "none" }}>
          {isInstructor ? "Enter room" : "Join the room"}
        </Button>
      </Flex>
    </Flex>
  );
};

export default LiveCard;
